import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { MentionsRequest } from 'src/requests/mentions';

export const useMentionsQuery = () => {
  const queryKey = ['mentions'];

  const { data: mentions, isFetching } = useQuery({
    queryKey,
    queryFn: () => MentionsRequest.getMentions(),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    refetchInterval: 60_000,
  });

  const unreadMentions = useMemo(
    () => mentions?.filter((m) => !m.readed),
    [mentions],
  );

  return {
    mentions,
    isFetching,
    unreadMentions,
  };
};
